<div class="empty-state">
  <mat-icon *ngIf="iconName" class="empty-state__icon">{{ iconName }}</mat-icon>
  <mat-icon *ngIf="!iconName && svgIconName" [svgIcon]="svgIconName" class="empty-state__icon" />
  <h1 *ngIf="title" class="empty-state__title">{{ title }}</h1>
  <p class="empty-state__description">
    <ng-content select="[state-description]" />
  </p>
  <button *ngIf="ctaSecondaryText" class="empty-state__cta" mat-button color="primary" (click)="secondaryAction()">
    {{ ctaSecondaryText }}
  </button>
  <button *ngIf="ctaPrimaryText" class="empty-state__cta" mat-raised-button color="primary" (click)="primaryAction()">
    {{ ctaPrimaryText }}
  </button>
</div>
